module.exports = __webpack_public_path__ + "static/img/quote.1f8f103.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/quote.png
// module id = 02AF
// module chunks = 226